import { auth } from '../configs/firebaseConfig';
import Login from '../pages/LoginPage';
import { type FC, type ReactNode, useEffect, useState } from 'react';

const Authentication: FC<{ children: ReactNode }> = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(auth.currentUser);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async user => {
      if (user) {
        localStorage.setItem('token', await user.getIdToken());
      } else {
        localStorage.removeItem('token');
      }
      setCurrentUser(user);
    });

    return unsubscribe;
  }, []);

  if (currentUser === null) {
    return <Login />;
  }

  return children;
};

export default Authentication;
